import { Package, RegistrationSession } from "@/api/dtos";
import { DEFAULT_SESSION_GROUP } from "@/constants/constants";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Alert, Divider, Grid, Typography, styled } from "@mui/material";
import { useScopedField } from "@ngt/forms-core";
import { FC, useCallback, useContext } from "react";
import PackageView from "./PackageView";
import PackageContext from "@/contexts/PackageContext";
import RegistrationField from "@/components/RegistrationField";
import ErrorView from "@/components/form/inputs/ErrorView";
import useSessions from "@/hooks/useSessions";

const usePackageId = () => {
    const {state: { value: packageId }, context: { setValue: setPackageId }} = useScopedField<number>("packageId", {value: true});

    return {packageId, setPackageId};
}

const usePackageChange = (isEarlyBird: boolean) => {
    const {context: { setValue: setPackageId }} = useScopedField<number>("packageId", { });
    const {context: {setValue: setRegistrationSessions}} = useScopedField<RegistrationSession[]>("sessions", { });
    //const {context: {setValue: setCost}} = useScopedField<number>("cost", { });

    return useCallback((packageInformation: Package) => {
        setPackageId(packageInformation.id, true, true, true, true);
        //setAttendeeCost(0);
        setRegistrationSessions(current => {
            const newSessions: RegistrationSession[] = [];
            
            if (packageInformation.sessions) {
                for (let session of packageInformation.sessions) {
                    if(!session.required){
                        const selectedSession = new RegistrationSession({ 
                            sessionId: session.id
                        });

                        if (session.required) {
                            (selectedSession as any).requiredGroup = session.requiredGroup  ?? DEFAULT_SESSION_GROUP;
                        }

                        newSessions.push(selectedSession);
                    }
                }
            }
            
            return newSessions;
        }, true, true, true, false);

        // if(!isEarlyBird || !packageInformation.discountPrice){
        //     setCost(packageInformation.price)
        // }
        // else{
        //     setCost(packageInformation.discountPrice)
        // }

        // window.scrollTo({
        //     top: 0,
        //     left: 0,
        //     behavior: 'smooth'
        // });
    }, [setPackageId, setRegistrationSessions, isEarlyBird])
}

const PackageName = styled(Typography)(({theme}) => ({
    fontWeight: 'bold',
}))

const PackageDescription = styled(Typography)(({theme}) => ({
    fontWeight: 'bold',
}))

const PackagePrice = styled(Typography)(({theme}) => ({
    fontWeight: 'bold',

}))

const GridLabels = styled(Grid)(({theme}) => ({
    width: '100%',
    textAlign: 'left',
    display: 'block',
    paddingLeft: '16px',
    paddingRight: '16px',

    [theme.breakpoints.up('md')]: {
        display: 'flex',
        gap: theme.spacing(3),
    },
    [theme.breakpoints.down('md')]: {
        display: 'none'
    }
}))

const GridRadio = styled(Grid)(({theme}) => ({
    flex: '1 1 10%',
    minWidth: 24,
    maxWidth: 24,
}))

const GridPackageName = styled(Grid)(({theme}) => ({
    flex: '1 1 40%'
}))

const GridPackageDescription = styled(Grid)(({theme}) => ({
    flex: '1 1 40%',
}))

const GridPackagePrice = styled(Grid)(({theme}) => ({
    flex: '1 1 10%',
    minWidth: 60,
    maxWidth: 60,
}))

const RenderPackagesV2: FC = ({
}) => {
    const {data: allSessions, loading: allSessionsLoading} = useSessions();

    const {packageId} = usePackageId();

    const {packages, isEarlyBird, packagesLoading: loading } = useContext(PackageContext);
    
    const onPackageChange = usePackageChange(isEarlyBird ?? false);

    if (loading || allSessionsLoading) {
        return (
            <Alert
                icon={<FontAwesomeIcon icon={faInfoCircle} />}
                severity="info"
                sx={{
                    alignItems: 'center'
                }}
            >
                Loading available packages based on your membership
            </Alert>
        )
    }
    
    return (
        <>
            <GridLabels>
                <GridRadio>
                </GridRadio>
                <GridPackageName>
                    <PackageName>
                        Package Name
                    </PackageName>
                </GridPackageName>
                <GridPackageDescription>
                    <PackageDescription>
                        Description         
                    </PackageDescription>
                </GridPackageDescription>
                <GridPackagePrice>
                    <PackagePrice>
                        Price         
                    </PackagePrice>
                </GridPackagePrice>
            </GridLabels> 
            <Divider sx={{marginBottom:'20px'}}></Divider>

            {
                packages?.map((packageInformation, i) => {
                    return (
                        <PackageView
                            key={packageInformation.id}
                            packageInformation={packageInformation}
                            index={i}
                            total={packages.length}
                            isEarlyBird={isEarlyBird ?? false}
                            selectedPackageId={packageId ?? undefined}
                            onPackageChange={onPackageChange}
                            allSessions={allSessions ?? []}
                        />
                    )   
                })
            }
            <RegistrationField
                propertyPath="packageId"
                component={ErrorView}
                view="Alerts"
            />
        </>
    )
}

export default RenderPackagesV2;